module.exports = __webpack_public_path__ + "static/media/business-loan-1.b478df2f.jpeg";